<template>
  <section class="intro">
    <div class="inner">
      <a class="config-buy" href="#products">
        <img alt="Configure and buy" src="../assets/ripple.svg"> Configure &amp; buy now
      </a>
      <span v-html="$store.state.page.main_text"></span>
    </div>
  </section>
</template>

<script>
export default {
  name: "Intro"
}
</script>

<style scoped>
.intro .config-buy {
  float: right;
  margin-top: 0;
  margin-bottom: 2rem;
  margin-left: 2rem;
}

.intro h1 {
  border-bottom: 3px solid #f79227;
  display: inline-block;
}

.intro p {
  max-width: 1000px;
}

@media screen and (max-width: 950px) {
  .intro .config-buy {
    float: none;
    margin: auto;
    margin-top: 2rem;
    margin-bottom: 2rem;
    clear: both;
    display: block;
    width: 100%;
  }
}
</style>
